module.exports = __webpack_public_path__ + "img/driver-empty-img1.1bf4fdc9.png";